




























import { Vue, Component } from "@/shared/vuepack";
import { useBrowserStore } from "@/employee/store/browser";
import { Home as HomeRouteName } from "@/employee/route-names";
import { browserNameMap, browserIconMap } from "@/shared/types";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import { domain as hsaBankDomain } from "@/shared/hsaBankUrls";

@Component({
  components: {
    LoginWrapper
  }
})
export default class UnsupportedBrowser extends Vue {
  browserStore = useBrowserStore();

  get browserName () {
    if (!this.browserStore.browser) {
      return "Unknown";
    }

    return this.browserStore.browser;
  }

  get browserVersion () {
    if (!this.browserStore.browserVersion) {
      return "Unknown";
    }

    const browserVersion = this.browserStore.browserVersion;
    const index = browserVersion.indexOf(".");

    if (index >= 0) {
      return browserVersion.substring(0, index);
    }

    return browserVersion;
  }

  get minVersion () {
    return this.browserStore.minVersion;
  }

  get supportedBrowsers () {
    if (!this.browserStore.browserRules) {
      return [];
    }

    return Object.entries(this.browserStore.browserRules).map(([browser, minVersion]) => {
      const icon = browserIconMap[browser];

      return {
        name: browserNameMap[browser],
        minVersion,
        icon: require(`@/assets/${icon}`)
      };
    });
  }

  get homepageUrl () {
    return `https://${hsaBankDomain}`;
  }

  mounted () {
    if (!this.browserStore.isUnsupported) {
      this.$router.push({ name: HomeRouteName });
    }
  }
}
